import * as THREE from 'three';

export const genRenderer = (_window) =>{
    let render = new THREE.WebGLRenderer({antialias:true,alpha: true});
    render.setClearColor(new THREE.Color(0xff0000));
    render.setSize(_window.width, _window.height);
    return render;
}

export const genCSS2Renderer = (_window) =>{
    let render = new THREE.CSS2DRenderer();
    render.setSize(_window.width, _window.height);
    render.domElement.style.position = 'absolute';
    render.domElement.style.top = '0px';
    return render;
}